import {PayloadAction} from '@reduxjs/toolkit';
import {ContentFeedPageState} from '../contentFeeds.store.types';
import contentFeedPageBaseReducer from './reducers/contentFeedPageBase.slice';
import contentFeedContentSetsReducer from './reducers/contentFeedContentSets.slice';
import contentFeedDrawerReducer from './reducers/contentFeedDrawer.slice';

const contentFeedPageReducer = (state: ContentFeedPageState, action: PayloadAction) => {
  const baseReducer = contentFeedPageBaseReducer(state, action);

  return {
    isLoading: baseReducer.isLoading,
    feed: baseReducer.feed,
    drawer: contentFeedDrawerReducer(state?.drawer, action),
    contentSets: contentFeedContentSetsReducer(state?.contentSets, action),
  };
};

export default contentFeedPageReducer;
